export function columnTheme() {
  return {
    "&:nth-child(1)": {
      width: "100px",
    },
    "&:nth-child(2)": {
      width: "100px",
    },
    "&:nth-child(3)": {
      minWidth: "50px",
      width: "50px",
    },
    "&:nth-child(4)": {
      width: "300px",
    },
    "&:nth-child(5)": {
      width: "180px",
    },
    "&:nth-child(6)": {
      width: "200px",
    },
    "&:nth-child(7)": {
      minWidth: "100px",
      width: "150px",
    },
  }
}
